import * as React from 'react'
import { connect } from "react-redux";
import { ActionType, cashierType, reducerStoreType } from "../../reducers/types";
import { Dispatch } from "redux";
import FormControl from "@material-ui/core/FormControl";
import { MyInput } from "../../components/CustomUIComp/CustomFormElem";
import './ScanQrModal.scss'
import { injectIntl, IntlShape } from "react-intl";

interface IProps {
  dispatch: Dispatch<ActionType<any>>,
  cashier: cashierType,
  currency: string,
  onClose: () => void,
  intl: IntlShape
}

interface IState {
  buyer: string,
}

class ScanQrModal extends React.Component<IProps, IState> {
  private inputRef = React.createRef<HTMLInputElement>();
  private interval: number = 0;

  constructor(props: IProps) {
    super(props)
    this.state = {
      buyer: ''
    }
  }

  componentDidMount() {
    this.interval = window.setInterval(() => {
      if (this.inputRef && this.inputRef.current) {
        this.inputRef.current.focus()
      }
    }, 1000)
  }

  componentWillUnmount() {
    console.log('unmount')
    if (this.interval > 0) {
      clearInterval(this.interval)
      this.interval = 0
    }
  }

  createOrder = (buyer: string) => {
    this.props.dispatch({
      type: 'CREATE_ORDER',
      payload: {
        orderType: 'scanQr',
        data: {
          amt: Number(this.props.cashier.amt),
          tradeSummary: this.props.cashier.remark,
          buyer: buyer,
          currency: this.props.cashier.checkcurr,
        }
      }
    })
  }

  onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      if (this.interval > 0) {
        clearInterval(this.interval)
        this.interval = 0
      }
      this.createOrder(this.state.buyer)
    }
  }
  onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      buyer: event.target.value
    })
  }

  public render() {
    let { intl } = this.props
    return (<div className="scanQrModal">
      <div
        className="tradeInfo">{intl.formatMessage({ id: 'collecting' })} {this.props.cashier.checkcurr} {this.props.cashier.amt}</div>
      {this.props.cashier.remark ?
        <div
          className="tradeRemark">{intl.formatMessage({ id: 'remark' })}: {this.props.cashier.remark}</div> : null}
      {/*<span className="buyer">用户收款码: {this.state.buyer || '请扫描用户付款码'}</span>*/}
      <FormControl className="formControl" fullWidth>
        <MyInput id="buyer"
          inputRef={this.inputRef}
          autoFocus={true}
          fullWidth
          type="number"
          name="buyer"
          placeholder={intl.formatMessage({ id: 'scanOrEnterPayQr' })}
          value={this.state.buyer}
          onKeyDown={this.onKeyDown}
          onChange={this.onInputChange}
        />
      </FormControl>

    </div>);
  }
}

export default injectIntl(connect((state: reducerStoreType) => {
  return {
    cashier: state.dashboard.cashier,
    currency: state.merchant.merchantInfo.currency
  }
})(ScanQrModal))
